import { useEffect } from 'react';

function setFavicon(href) {
  if (!href) return;

  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}

/** Sets document title + favicon for the current section (storefront vs admin). */
export function usePageBrand({ title, favicon }) {
  useEffect(() => {
    if (title) document.title = title;
    setFavicon(favicon);
  }, [title, favicon]);
}
